"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanoramaMarker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PanoramaCircleMarker_1 = require("./PanoramaCircleMarker");
function PanoramaMarker({ onClick: onClickCallback, interactive }) {
    const [popupOpen, setPopupOpen] = (0, react_1.useState)(false);
    const [isOver, setIsOver] = (0, react_1.useState)(false);
    const onClick = () => {
        window.dispatchEvent(new Event('close'));
        setIsOver(false);
        onClickCallback?.();
    };
    (0, react_1.useEffect)(() => {
        const close = () => {
            setPopupOpen(false);
        };
        window.addEventListener('close', close);
        return () => {
            window.removeEventListener('close', close);
        };
    }, []);
    const focused = (0, react_1.useMemo)(() => (isOver || popupOpen) && interactive, [isOver, popupOpen]);
    const size = (0, react_1.useMemo)(() => focused ? 18 : 15, [focused]);
    const color = "#0275d8";
    const transition = "all 0.1s ease-out";
    return (0, jsx_runtime_1.jsx)(PanoramaCircleMarker_1.PanoramaCircleMarker, { size: size, color: color, focused: focused, onClick: onClick, onMouseOverChange: setIsOver });
}
exports.PanoramaMarker = PanoramaMarker;
